
/*
----- Table Column Equaliser ----- 
When displaying columns of numberic values it is prefered that they all appear in a centeralised container inside of the table column with the text inside of that container either being left or right aligned.

No we currently cannot do this with css as we dont know the container's width nor can we calculated depending on the max width in a seleciton.

This was originally called axis-text-equaliser but had a major refactor for 840614 due to performance concerns.
*/


var instances = {};

function getInstance(context) {
    if (!context || !context.length) {
        AXISDebug.output(3,"Table Column Equaliser: You must provide a valid context.", context);
        return false;
    }
    // Extract instance ID.
    let id = context.attr(expressSelectors()['axis-table-column-equaliser']['instance-id']);
    if (!id) {
        AXISDebug.output(3,"Table Column Equaliser: Could not obtain Id from context, has it be initialised?", context);
        return false;
    }
    // Find instance using ID.
    if (instances.hasOwnProperty(id)) {
        return id;
    } else {
        AXISDebug.output(3,"Table Column Equaliser: Could not find instance " + id + " in instances object.", instances);
        return false;
    }
}

function setContext(id, value) {
    return instances[id]['context'] = value;
}

function getContext(id) {
    return instances[id]['context'];
}

function setResponsiveState(id, value) {
    return instances[id]['is-responsive-table'] = value;
}

function getResponsiveState(id) {
    return instances[id]['is-responsive-table'];
}

function setResponsiveBreakpoint(id, value) {
    return instances[id]['breakpoint'] = value;
}

function getResponsiveBreakpoint(id) {
    return instances[id]['breakpoint'];
}

function setColumnContext(id, groupId, value) {
    if (!instances[id]['columns'].hasOwnProperty(groupId)) {
        instances[id]['columns'][groupId] = {};
        instances[id]['columns'][groupId]['column-contexts'] = [];
        instances[id]['columns'][groupId]['widths'] = [];
    }
    return instances[id]['columns'][groupId]['column-contexts'].push(value);
}

function getColumns(id) {
    return instances[id]['columns'];
}

function setColumnHasPDF(id, groupId, value) {
    return instances[id]['columns'][groupId]['has-pdf'] = value;
}

function getColumnHasPDF(id, groupId) {
    return instances[id]['columns'][groupId]['has-pdf'];
}

function setColumnAlignment(id, groupId, value) {
    return instances[id]['columns'][groupId]['column-alignment'] = value;
}

function getColumnAlignment(id, groupId) {
    // Check if group exists.
    if (instances[id]['columns'].hasOwnProperty(groupId)) {
        return instances[id]['columns'][groupId]['column-alignment'];
    } else {
        return false;
    }
}

function setInstanceActiveState(id, value) {
    return instances[id]['active'] = value;
}

function getInstanceActiveState(id) {
    return instances[id]['active'];
}


// Initialise on page load.
function initialiseAll() {
    // Changed to use a promise bases solution as Safari current doesn't fire onloaddone event for fonts, this is a know bug https://bugs.webkit.org/show_bug.cgi?id=279661
    document.fonts.ready.then(() => {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Table Column Equaliser: Fonts have now loaded initialisation can now begin.");
        }
        // Adding .text-container to initialise for backwards compatibility.
        $('table:has([' + expressSelectors()['axis-table-column-equaliser']['initialise'] + '], .text-container)').each(function() {
            // Get Context.
            let context = $(this);
            let init = initialise(context);
        });
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Table Column Equaliser: Finished initialisation process, here are the instances:", instances);
        }
    });
}

// Add breakpoint change listener to re-equalise.
$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
    for (let [id, config] of Object.entries(instances)) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Table Column Equaliser: Breakpoint change detected", id);
        }
        equalise(id).catch((error) => console.error(error));
    };
});

// Check whether we need to clean up old instances, i.e instances that are no longer in the DOM after Ajax.
function instanceCleanup() {
    for (let [id, config] of Object.entries(instances)) {
        let context = $('[' + expressSelectors()['axis-table-column-equaliser']['instance-id'] + '="' + id + '"]');
        if (!context.length) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Table Column Equaliser: Instance " + id + " no longer exists, proceeding to destroy.");
            }
            // Clear our instance.
            delete instances[id];
        }
    }
}

// Initialise instance.
function initialise(context) {
    if (!context.length) {
        AXISDebug.output(3,"Table Column Equaliser: Context must be provided", context);
        return false;
    }
    // Make sure context is a table.
    if (!context.is('table')) {
        // If no then find closest, Fallback support as we used to initialise off each element inside of the table rather than the table itself.
        context = context.closest('table');
    }
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Table Column Equaliser: Attempting to initialise.", context);
    }
    // Get Instance Id.
    let id = context.attr(expressSelectors()['axis-table-column-equaliser']['instance-id']);
    // If no instance then create one.
    if (!id) {
        context.attr(expressSelectors()['axis-table-column-equaliser']['instance-id'], generateId());
        id = context.attr(expressSelectors()['axis-table-column-equaliser']['instance-id']);
        instances[id] = {};
        // Create columns object.
        instances[id]['columns'] = {};
        // Update instance.
        setContext(id, context);
    } else {
        return false;
    }
    // Is it a responsive table?
    let responsive = (context.attr(expressSelectors()['tables']['responsive-tables']) != undefined);
    // Update instance.
    setResponsiveState(id, responsive);
    // Check if there is a responsive start for this instance.
    let breakpoint = context.attr(expressSelectors()['axis-table-column-equaliser']['responsive-start']);
    // Update instance.
    setResponsiveBreakpoint(id, breakpoint);
    // Find any columns that are attempting to initalise using the old class instead of a data attribute.
    let legacyColumns = context.find('.text-container:not([' + expressSelectors()['axis-table-column-equaliser']['initialise'] + '])');
    // If legacy columns found then add in correct attribute to 
    if (legacyColumns.length) {
        AXISDebug.output(2,"Table Column Equaliser: Legacy Column support trigged, please add the following attribute ' " + expressSelectors()['axis-table-column-equaliser']['initialise'] + " ' and remove ' text-container ' class from the following elements", legacyColumns);
        legacyColumns.attr(expressSelectors()['axis-table-column-equaliser']['initialise'], '');
        legacyColumns.removeClass('text-container');
    }
    // Build column config before equalisation.
    buildColumnConfig(id).then((columnConfig) => {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Table Column Equaliser: Column config built, moving onto equalisation", columnConfig);
        }
        equalise(id).then(() => {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Table Column Equaliser: Equalisation Finished", context);
            }
        }).catch((error) => console.error(error));
    }).catch((error) => console.error(error));
}

function buildColumnConfig(id) {
    return new Promise((resolve, reject) => {
        // Get context.
        let context = getContext(id);
        // Build column configuration.
        // Get equalise coluimns context.
        let columns = context.find('[' + expressSelectors()['axis-table-column-equaliser']['initialise'] + ']');
        // Fallback to pre data attribute initialisation.
        if (!columns.length) {
            columns = context.find('.text-container');
        }
        // Loop though columns adding them to memory.
        columns.each(function() {
            // Column.
            let item = $(this);
            // Containing column.
            let column = item.parents('td');
            // Use class for the group id.
            let groupId = column.attr('class');
            if (!groupId) {
                reject("Table Column Equaliser: No class on column ( parent <td> ), this is required as it gets used for the group id");
                return false;
            }
            // Update instance - Add Column to instance.
            setColumnContext(id, groupId, item);
            // Check whether class is assigned.
            if (!item.hasClass('text-container')) {
                item.addClass('text-container');
            }
            // Check if this column has any pdf's.
            let hasPDF = (column.find('.pdf-download').length > 0);
            // Update instance.
            setColumnHasPDF(id, groupId, hasPDF)
            
            // How will the content be aligned inside of the container, default to right.
            let alignment = "align-right";
            if (item.hasClass('align-center')) {
                alignment = "align-center";
            } else if (item.hasClass('align-left')) {
                alignment = "align-left";
            } else {
                // Fallback.
                item.addClass(alignment);
            }
            // Update instance.
            setColumnAlignment(id, groupId, alignment);
        });

        // Find table header.
        let tableHeader = context.find('thead');
        if (tableHeader) {
            // Loop through columns that have equaliser instance.
            for (let [groupId, columnConfig] of Object.entries(getColumns(id))) {
                // Table Head column context.
                let column = tableHeader.find('th.' + groupId);
                if (column.length) {
                    // Check if column header content is wrapped in a container, if not then wrap it.
                    if (!column.find('[' + expressSelectors()['axis-table-column-equaliser']['column-heading'] + ']').length) {
                        // Group Alignment.
                        let alignment = getColumnAlignment(id, groupId);
                        // Update DOM.
                        column.wrapInner('<span class="text-container column-header-content ' + alignment + '" ' + expressSelectors()['axis-table-column-equaliser']['column-heading'] + '></span>');
                        // Update context with actual content instead of the <th>, as we don't want to apply the height directly the the th.
                        column = column.find('[' + expressSelectors()['axis-table-column-equaliser']['column-heading'] + ']');
                    }
                    // Update instance.
                    setColumnContext(id, groupId, column);
                } else {
                    if (AXISDebug.level() >= 2) {
                        AXISDebug.output(2,"Table Column Equaliser: Could not find column (" + groupId + ") in header", context);
                    }
                }
            }
        }
        resolve(getColumns(id));
    });
    
}

// Run equalisation functionality.
function equalise(id) {
    return new Promise((resolve, reject) => {
        if (!id) {
            reject("Table Column Equaliser: Could not find instance.");
        }
        // Get context.
        let context = getContext(id);
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Table Column Equaliser: Attempting to run equaliser for", context);
        }
        // Get columns.
        let columns = getColumns(id);
        // Get breakpoint.
        let breakpoint = getResponsiveBreakpoint(id);
        if (breakpoint) {
            if (!responsiveStart(breakpoint)) {
                // If previously active then reset.
                if (getInstanceActiveState(id)) {
                    if (AXISDebug.level() >= 3) {
                        AXISDebug.output(1,"Table Column Equaliser: Resetting column widths due to viewport is bellow start breakpoint", context);
                    }
                    columnsCleanup(id);
                }
                resolve();
            }
        }
        // Is this a repsonsive table?
        let responsive = getResponsiveState(id);
        if (currentBreakpoint() < 3 && responsive) {
            // If previously active then reset.
            if (getInstanceActiveState(id)) {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Table Column Equaliser: Resetting column widths as current breakpoint < 3 and this is a respnsive table", context);
                }
                columnsCleanup(id);
            }
            resolve();
        }
        // Reset to prevent previous values from being used in next calculation.
        if (getInstanceActiveState(id)) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Table Column Equaliser: Equaliser had previously been active, running cleanup to prevent previous widths from being used in next calculation.", id);
            }
            columnsCleanup(id);
        }

        // Reset all CSS properties.
        for (let [groupId, column] of Object.entries(columns)) {
            let groupHasPDF = getColumnHasPDF(id, groupId);
            for (let index = 0; index < column['column-contexts'].length; index++) {
                let element = column['column-contexts'][index];
                if (groupHasPDF) {
                    let pdfElement = (element.find('.pdf-download').length > 0);
                    if (!pdfElement) {
                        element.parent('td').addClass('no-pdf-download');
                    }
                }
                element.css('width', '');
                element.css('max-width', '100%');
                element.css('display', 'inline-flex');
            }
        }

        // Measure all elements (batch read)
        for (let [groupId, column] of Object.entries(columns)) {
            column['widths'] = [];
            for (let index = 0; index < column['column-contexts'].length; index++) {
                let element = column['column-contexts'][index];
                let width = Math.ceil(element[0].getBoundingClientRect().width);
                column['widths'].push(width);
            }
        }

        // Apply max widths (batch write).
        for (let [groupId, column] of Object.entries(columns)) {
            let max = Math.max(...column['widths']);
            for (let index = 0; index < column['column-contexts'].length; index++) {
                let element = column['column-contexts'][index];
                element.css('width', max);
            }
            setInstanceActiveState(id, true);
            if (AXISDebug.level() >= 4) {
                AXISDebug.output(1,"Table Column Equaliser: Max width calculated " + max + "px for Column " + groupId);
            }
        }
    });
}

// Column clean up function typically used during equalisation.
function columnsCleanup(id) {
    if (!id) {
        AXISDebug.output(3,"Table Column Equaliser: Cannot perform column cleanup without instance id", id);
        return false;
    }
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Table Column Equaliser: Attempting to run Column cleanup for instance", id);
    }
    // Get Columns context.
    let columns = getColumns(id);
    if (!columns) {
        AXISDebug.output(3,"Table Column Equaliser: Could not find columns for instance", id);
        return false;
    }
    // Loop though configs.
    for (let [groupId, config] of Object.entries(columns)) {
        // Loop though column contexts.
        config['column-contexts'].forEach(column => {
            column.css('width', '');
            column.css('max-width', '');
            column.css('display', '');
        });
    }
    // Set instance in-active.
    setInstanceActiveState(id, false);
    return true;
}

// Which breakpoint to use this functionality at.
function responsiveStart(breakpoint) {
    // Get numeric value of starting breakpoint.
    breakpoint = getBreakpoint(breakpoint);
    // If the starting breakpoint is >= currentBreakpoint then allow initialisation to take place.
    if (currentBreakpoint() >= breakpoint) {
        return true;
    } else {
        return false;
    } 
}

var AXISTableColumnEqualiser = $.AXISTableColumnEqualiser = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        // As this method is most likely being called after we have AJAX'd content in, we may need to destroy older instance(s).
        instanceCleanup();
        return initialise(context);
    },
    equalise: (context) => {
        // TODO: You may have problem here if this module is dynamically loaded in if .equalise gets called before an instance is initialised
        let id = getInstance(context);
        if (id) {
            return equalise(id);
        } else {
            return false;
        }
    }
}

export { AXISTableColumnEqualiser };